export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const getResultLabel = (result) => {
  const labels = {
    'H': 'Local',
    'Home': 'Local',
    'D': 'Empate',
    'Draw': 'Empate',
    'A': 'Visitante',
    'Away': 'Visitante'
  };
  return labels[result] || result;
};

export const getConfidenceColor = (confidence) => {
  if (confidence >= 0.6) return '#10b981';
  if (confidence >= 0.45) return '#f59e0b';
  return '#ef4444';
};